var React = require('react');

function ChevronSDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 10L12 14L8 10","stroke":"#0088BF","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ChevronSDown.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ChevronSDown;

ChevronSDown.default = ChevronSDown;
